module.exports = __webpack_public_path__ + "static/media/icon-feedback.36b7cda7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-feedback.svg
// module id = 1563
// module chunks = 0